import type { JSONFieldValues } from "@adrekic/fieldsjson"
import { ConditionManager, FieldSchema } from "@overmap-ai/forms"

import { ProcedureStepCompletionStatus } from "../enums/procedures"

export function getProcedureStepCompletionStatus(
	fieldSchema: FieldSchema,
	conditionManager: ConditionManager,
	values?: JSONFieldValues,
	isDraft?: boolean,
): ProcedureStepCompletionStatus {
	if (!values || isDraft) return ProcedureStepCompletionStatus.INCOMPLETE

	const completed =
		conditionManager.getConditions().length === 0 ||
		conditionManager.applyConditions(fieldSchema.initializeValues(fieldSchema.deserializeValues(values)))

	return completed ? ProcedureStepCompletionStatus.COMPLETE : ProcedureStepCompletionStatus.FAILED
}
